import { ItemCombobox } from '@models-global/model-combobox-item';

export enum CustomerServiceType {
  REBATE_OPERATIONS = 0,
  AUDIT_340B = 1,
  HEALTH_SYSTEM = 2,
  PHARMACY_CHAIN = 3
}

export const MAP_CUSTOMER_SERVICE_TYPE = {
  [CustomerServiceType.REBATE_OPERATIONS]: 'Rebate Operations',
  [CustomerServiceType.AUDIT_340B]: '340B Audit',
  [CustomerServiceType.HEALTH_SYSTEM]: 'Health System',
  [CustomerServiceType.PHARMACY_CHAIN]: 'Pharmacy Chain'
};

export const ARRAY_CUSTOMER_SERVICE_TYPE: ReadonlyArray<ItemCombobox> = [
  {
    value: CustomerServiceType.AUDIT_340B,
    text: MAP_CUSTOMER_SERVICE_TYPE[CustomerServiceType.AUDIT_340B]
  },
  {
    value: CustomerServiceType.REBATE_OPERATIONS,
    text: MAP_CUSTOMER_SERVICE_TYPE[CustomerServiceType.REBATE_OPERATIONS]
  },
  {
    value: CustomerServiceType.HEALTH_SYSTEM,
    text: MAP_CUSTOMER_SERVICE_TYPE[CustomerServiceType.HEALTH_SYSTEM]
  },
  {
    value: CustomerServiceType.PHARMACY_CHAIN,
    text: MAP_CUSTOMER_SERVICE_TYPE[CustomerServiceType.PHARMACY_CHAIN]
  }
];
